// extracted by mini-css-extract-plugin
export default {"formHolder":"CompanyForm_formHolder__cLuCR","formfield":"CompanyForm_formfield__TEyVZ","select":"CompanyForm_select__u4b9G","fieldLabel":"CompanyForm_fieldLabel__n1NPM"};